import axios from "axios";

export const TOKEN_KEY = "bni-devadmin-token";
export const EVENT_KEY = "bni-devadmin-event";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/devadmin` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// If any request comes back 401 (expired/invalid token) wipe the stale creds and bounce the user
// back to the login screen with a visible message — otherwise "Save fees" silently fails and
// nobody realises the backend was rejecting every write.
let _bouncing = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 401 && !_bouncing) {
      _bouncing = true;
      try {
        localStorage.removeItem(TOKEN_KEY);
        // dynamic import to avoid pulling sonner into the lib file if the toast isn't mounted yet
        import("sonner").then(({ toast }) => toast.error(
          typeof detail === "string" && detail ? `${detail} — please sign in again` : "Session expired — please sign in again",
          { duration: 6000 }
        )).catch(() => {});
      } catch (_) { /* ignore */ }
      // Give the toast a beat to render, then redirect
      setTimeout(() => { window.location.assign("/devadmin"); }, 400);
    }
    return Promise.reject(err);
  }
);

export function errText(e) {
  const d = e?.response?.data;
  if (!d) return e?.message || "Request failed";
  if (Array.isArray(d.errors) && d.errors.length) return d.errors.map((x) => `${x.field}: ${x.message}`).join(" · ");
  if (typeof d.detail === "string") return d.detail;
  if (d.detail?.errors) return d.detail.errors.map((x) => `${x.field}: ${x.message}`).join(" · ");
  return JSON.stringify(d.detail || d);
}

export function fieldErrors(e) {
  const list = e?.response?.data?.errors || e?.response?.data?.detail?.errors || [];
  return Object.fromEntries(list.map((x) => [x.field, x.message]));
}
